import { Box } from "../Box";
import { IBoxState } from "./IBoxState";

export class BoxIdleState implements IBoxState {
    public constructor(private readonly box: Box, private readonly nextState: IBoxState) {
    }
    public enter(_previousState: IBoxState): void {
    }
    public exit(): void {
    }
    public process(_dt: number): IBoxState {
        if (this.box.health == 0 || this.box.isLifetimeOver) {
            return this.nextState;
        }
        return this;
    }

}